import { receiveType, ReceiveType } from "./receiveTypeMapping";

export function getFreightCostHighWarning(recType?: ReceiveType | string): string {
	const verb = recType?.toLowerCase() === receiveType.manual.toLowerCase() ? "submitting" : "finalising";
	return `The freight value you entered is higher than expected - please double check it matches the freight cost ex shown on the invoice before ${verb} the receive.`;
}

const HIGH_FREIGHT_COST_ABSOLUTE_THRESHOLD = 90;
const HIGH_FREIGHT_COST_LINE_TOTAL_RATIO = 0.4;

/**
 * Determines whether the entered freight cost (ex) appears unusually high.
 * Returns true when the freight is greater than $90, or greater than 40% of the
 * line item total (ex). The ratio check is only applied when there is a line total
 * to compare against, to avoid false positives before any line items are entered.
 */
export function isFreightCostHigh(
	freightCostEx: number | string | undefined | null,
	lineTotalCostEx: number | string | undefined | null
): boolean {
	const freight = Number(freightCostEx) || 0;
	const lineTotal = Number(lineTotalCostEx) || 0;

	return (
		freight > HIGH_FREIGHT_COST_ABSOLUTE_THRESHOLD ||
		(lineTotal > 0 && freight > lineTotal * HIGH_FREIGHT_COST_LINE_TOTAL_RATIO)
	);
}
